import React from 'react'

const Footer = () => {
    return (
        <div>
             <footer class="sticky-footer bg-white">
                <div class="container my-auto">
                    <div class="copyright text-center my-auto">
                        <span>Copyright &copy; Abhiraj Agrovet Pvt. Ltd. {new Date().getFullYear()}</span>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer
